"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function getStateKeyFromApiPath(apiPath) {
  return apiPath.replace(/^\/|\/$/g, '').split('?')[0].split('/')[0];
}

var _default = getStateKeyFromApiPath;
exports["default"] = _default;